var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomePostsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 901 901"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6D7B8E",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 5,
    opacity: 0.327,
    cx: 451,
    cy: 450.5,
    rx: 262.5,
    ry: 263
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 4,
    opacity: 0.176,
    cx: 450.5,
    cy: 450.5,
    r: 448.5
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOTAxcHgiIGhlaWdodD0iOTAxcHgiIHZpZXdCb3g9IjAgMCA5MDEgOTAxIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPkdyb3VwIDM1PC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIyMDIxX0hvbWVwYWdlUmVmcmVzaCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDcyLjAwMDAwMCwgLTQ1NTguMDAwMDAwKSIgc3Ryb2tlPSIjNkQ3QjhFIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTM1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDcyLjAwMDAwMCwgNDU1OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsLUNvcHktNiIgc3Ryb2tlLXdpZHRoPSI1IiBvcGFjaXR5PSIwLjMyNzQyNzQ1NSIgY3g9IjQ1MSIgY3k9IjQ1MC41IiByeD0iMjYyLjUiIHJ5PSIyNjMiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtQ29weS02IiBzdHJva2Utd2lkdGg9IjQiIG9wYWNpdHk9IjAuMTc2MDgzNTE5IiBjeD0iNDUwLjUiIGN5PSI0NTAuNSIgcj0iNDQ4LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgHomePostsCircle as ReactComponent };